module.exports = __webpack_public_path__ + "img/default-avatar.9535fc84.png";